<div class="wide admin-panel-application-history">
  <p-table
    #table
    (onSort)="onPrimeSortChange($event)"
    [lazy]="true"
    [loading]="isDataLoading()"
    [rows]="tablePage()?.size || 10"
    [scrollable]="true"
    scrollHeight="flex"
    [tableStyle]="{ 'min-width': '60rem' }"
    [totalRecords]="tablePage()?.totalElements || 0"
    [value]="rows()"
    dataKey="id"
    class="customPrimeTable"
  >
    <ng-template #header>
      <tr class="filters-row">
        <th pSortableColumn="eventDate">
          <div class="flex items-center gap-2">
            Data
            <p-sortIcon field="eventDate" />
          </div>
        </th>
        <th pSortableColumn="eventObject">
          <div class="flex items-center gap-2">
            Obiekt
            <p-sortIcon field="eventObject" />
          </div>
        </th>
        <th pSortableColumn="eventType">
          <div class="flex items-center gap-2">
            Rodzaj
            <p-sortIcon field="eventType" />
          </div>
        </th>
        <th pSortableColumn="eventAuthor">
          <div class="flex items-center gap-2">
            Autor
            <p-sortIcon field="eventAuthor" />
          </div>
        </th>
        <th
          alignFrozen="right"
          pFrozenColumn
          style="width: 88px; min-width: 88px"
        >
          <div class="flex justify-center">Akcje</div>
        </th>
      </tr>
      <tr>
        <td class="table-filter-cell">
          <p-date-picker
            (onClear)="onPrimeFilterChange($event, 'eventDate')"
            (onSelect)="onPrimeFilterChange($event, 'eventDate')"
            [readonlyInput]="true"
            [showClear]="true"
            [(ngModel)]="tableFilters.eventDate"
            appendTo="body"
            class="w-full customDatePicker"
            dateFormat="dd-mm-yy"
            ariaLabel="Filtruj po dacie"
          />
        </td>
        <td class="table-filter-cell">
          <p-select
            (onChange)="onPrimeFilterChange($event.value, 'eventObject')"
            [options]="eventObjectOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.eventObject"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            class="w-full"
            ariaLabel="Filtruj po obiekcie"
          ></p-select>
        </td>
        <td class="table-filter-cell">
          <p-select
            (onChange)="onPrimeFilterChange($event.value, 'eventType')"
            [options]="eventTypeOptions"
            [showClear]="true"
            [(ngModel)]="tableFilters.eventType"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            class="w-full"
            ariaLabel="Filtruj po rodzaju"
          ></p-select>
        </td>
        <td class="table-filter-cell">
          <div class="max-w-48">
            <input
              (change)="onPrimeFilterChange($event.target, 'eventAuthor')"
              aria-label="Filtruj po autorze"
              pInputText
              class="w-full"
              [(ngModel)]="tableFilters.eventAuthor"
            />
          </div>
        </td>
        <td
          class="table-filter-cell"
          alignFrozen="right"
          pFrozenColumn
          style="width: 88px; min-width: 88px"
        ></td>
      </tr>
    </ng-template>
    <ng-template #body let-row>
      <tr>
        <td>{{ row.eventDate | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
        <td>{{ row.eventObject }}</td>
        <td>{{ ApplicationUtils.getApplicationEventTypeLabel(row.eventType) }}</td>
        <td>{{ row.eventAuthor }}</td>
        <td
          alignFrozen="right"
          pFrozenColumn
          style="width: 88px; min-width: 88px"
        >
          <div class="flex justify-center">
            <p-button
              type="button"
              icon="pi pi-eye"
              [text]="true"
              [rounded]="true"
              ariaLabel="Zobacz szczegóły"
              class="customShowMoreButton"
              pTooltip="Zobacz szczegóły"
              tooltipPosition="top"
              (click)="showDetails(row)"
            />
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td colspan="5">Brak danych</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="table-footer">
    <div class="table-pagination">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[10, 25, 50]"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements || 0"
        pageLinkSize="3"
        class="customPrimePaginator"
      />
      <div class="table-meta">
        Strona {{ (tablePage()?.number || 0) + 1 }} z
        {{ tablePage()?.totalPages || 0 }}
      </div>
    </div>

    <div class="flex justify-end mt-6">
      <p-button
        label="Zamknij"
        styleClass="customInfoButton outlined"
        (click)="close()"
      />
    </div>
  </div>
</div>

<div class="narrow admin-panel-application-history">
  <p-card class="mb-4">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="eventDateMobileLabel">Data</span>
        <p-date-picker
          ariaLabelledBy="eventDateMobileLabel"
          (onClear)="onPrimeFilterChange($event, 'eventDate')"
          (onSelect)="onPrimeFilterChange($event, 'eventDate')"
          [readonlyInput]="true"
          [showClear]="true"
          [(ngModel)]="tableFilters.eventDate"
          appendTo="body"
          class="w-full customDatePicker"
          dateFormat="dd-mm-yy"
        />
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="eventObjectMobileLabel">Obiekt</span>
        <p-select
          ariaLabelledBy="eventObjectMobileLabel"
          (onChange)="onPrimeFilterChange($event.value, 'eventObject')"
          [options]="eventObjectOptions"
          [showClear]="true"
          [(ngModel)]="tableFilters.eventObject"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          class="w-full"
        ></p-select>
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="eventTypeMobileLabel">Rodzaj</span>
        <p-select
          ariaLabelledBy="eventTypeMobileLabel"
          (onChange)="onPrimeFilterChange($event.value, 'eventType')"
          [options]="eventTypeOptions"
          [showClear]="true"
          [(ngModel)]="tableFilters.eventType"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
          class="w-full"
        ></p-select>
      </div>
      <div class="flex flex-col gap-2">
        <span class="font-bold" id="eventAuthorMobileLabel">Autor</span>
        <input
          aria-labelledby="eventAuthorMobileLabel"
          (input)="onFilterChangeMobile($event.target, 'eventAuthor')"
          pInputText
          class="w-full"
          [(ngModel)]="tableFilters.eventAuthor"
        />
      </div>
      <div class="flex justify-end">
        <p-button
          type="button"
          label="Wyczyść filtry"
          styleClass="customInfoButton outlined"
          (click)="clearFilters()"
        />
      </div>
    </div>
  </p-card>
  <div class="flex flex-col gap-6">
    @for (row of rows(); track row.id) {
      <p-card>
        <div class="flex flex-col gap-2">
          <div>
            <span class="font-bold">Data</span>
            <div>{{ row.eventDate | date: 'yyyy-MM-dd HH:mm:ss' }}</div>
          </div>
          <div>
            <span class="font-bold">Obiekt</span>
            <div>{{ row.eventObject }}</div>
          </div>
          <div>
            <span class="font-bold">Rodzaj</span>
            <div>{{ ApplicationUtils.getApplicationEventTypeLabel(row.eventType) }}</div>
          </div>
          <div>
            <span class="font-bold">Autor</span>
            <div>{{ row.eventAuthor }}</div>
          </div>
          <div class="flex justify-end mt-2">
            <p-button
              type="button"
              label="Zobacz szczegóły"
              styleClass="customInfoButton outlined"
              aria-label="Zobacz szczegóły"
              (click)="showDetails(row)"
            />
          </div>
        </div>
      </p-card>
    } @empty {
      <p-card>Brak danych</p-card>
    }

    <div class="table-pagination">
      <p-paginator
        (onPageChange)="onPrimePageChange($event)"
        [rowsPerPageOptions]="[10, 25, 50]"
        [rows]="tablePage()?.size || 10"
        [totalRecords]="tablePage()?.totalElements || 0"
        pageLinkSize="3"
        class="customPrimePaginator"
      />
      <div class="table-meta">
        Strona {{ (tablePage()?.number || 0) + 1 }} z
        {{ tablePage()?.totalPages || 0 }}
      </div>
    </div>

    <div class="flex justify-end">
      <p-button
        label="Zamknij"
        styleClass="customInfoButton outlined"
        (click)="close()"
      />
    </div>
  </div>
</div>
